import React from 'react';

import { MobileSectionHeader } from '@/components/mobile/mobile-section-header';

interface MobilePropertiesSectionProps {
  siteAbbreviation?: string;
  salesRepresentative?: string;
  constructionCompany?: string;
  registrant?: string;
  registrationDateTime?: string;
  updater?: string;
  updateDateTime?: string;
}

/**
 * Mobile version of properties section showing plan details
 * Displays information in a card format matching Figma design
 */
export const MobilePropertiesSection: React.FC<MobilePropertiesSectionProps> = ({
  siteAbbreviation,
  salesRepresentative,
  constructionCompany,
  registrant,
  registrationDateTime,
  updater,
  updateDateTime,
}) => {
  const detailItems = [
    { label: '現場略称', value: siteAbbreviation || '-' },
    { label: '営業担当', value: salesRepresentative || '-' },
    { label: '建設会社', value: constructionCompany || '-' },
    { label: '登録者', value: registrant || '-' },
    { label: '登録日時', value: registrationDateTime || '-' },
    { label: '更新者', value: updater || '-' },
    { label: '更新日時', value: updateDateTime || '-' },
  ];

  return <MobileSectionHeader title='詳細' detailItems={detailItems} />;
};
